module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-credit-bonus-configuration"
  }, [_c('ModalReveal', {
    ref: "bonusModal",
    on: {
      "modalOpen": _vm.load
    },
    scopedSlots: _vm._u([{
      key: _vm.slot,
      fn: function(footer) {
        return [_c('button', {
          staticClass: "button update",
          on: {
            "click": _vm.update
          }
        }, [_vm._v("Save")])]
      }
    }], null, true)
  }, [(_vm.item !== null) ? _c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]) : _c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('addBonus')
      }
    },
    slot: "trigger"
  }, [_vm._v("Add Credit bonus")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.name),
      expression: "item.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "name", $event.target.value)
      }
    }
  }), _c('label', [_vm._v("Amount")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.amount),
      expression: "item.amount"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "amount", $event.target.value)
      }
    }
  }), _c('label', [_vm._v("Promo amount")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.promo_amount),
      expression: "item.promo_amount"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.promo_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "promo_amount", $event.target.value)
      }
    }
  }), _c('label', [_vm._v("Max days")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.max_days),
      expression: "item.max_days"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.max_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "max_days", $event.target.value)
      }
    }
  }), _c('label', [_vm._v("Description")]), _c('Editor', {
    model: {
      value: (_vm.item.description),
      callback: function($$v) {
        _vm.$set(_vm.item, "description", $$v)
      },
      expression: "item.description"
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Configuration")]), _c('ArrayEdit', {
    attrs: {
      "values": _vm.config,
      "options": _vm.fields
    }
  }), _c('label', [_vm._v("Fallbacks")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.fallback_rules),
      expression: "item.fallback_rules"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.fallback_rules)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "fallback_rules", $event.target.value)
      }
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-567c8a20!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/configuration/CreditBonusConfiguration.vue
// module id = 2513
// module chunks = 1